import React from 'react'
import ItemsEmptyGeneral from './ItemsEmptyGeneral'
import ItemsEmptyBonial from 'themes/bonial/components/ItemsEmpty'


export default ({ theme }) => {
    if (theme === 'bonial') {
        return <ItemsEmptyBonial />
    }

    return <ItemsEmptyGeneral />
}
